import ReactOnRails from 'react-on-rails';
import SignupPage from "../bundles/SignupPage";
import '../src/styles/signup.sass';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ SignupPage });
